<template>
    <div class="financeApplication__title" v-if="title || excerpt">
        <h2 v-if="title">{{ title }}</h2>
        <p v-if="excerpt">{{ excerpt }}</p>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
        },
        excerpt: {
            type: String
        }
    }
}
</script>